<ng-form #form="ngForm"
         [ngSwitch]="accountStatus">
    <section1 sectionIcon="account2"
              [isCurrent]="checkoutStepComponent.isCurrent"
              [sectionTitle]="sectionTitle">

        <checkout-expandable [expandableOff]="expandableOff"
                             sectionBody
                             [expandableId]="expandableId">
            <p class="truncate"
               expandableTitle>
                {{ email }}
            </p>

            <div expandableBody
                 class="m-t-10 m-t-6-s m-t-6-m">
                <!-- welcome -->
                <ng-container *ngSwitchCase="EAccountStatus.welcome">
                    <ng-container *ngTemplateOutlet="emailTpl"></ng-container>
                    <ng-container *ngTemplateOutlet="continueTpl"></ng-container>
                </ng-container>

                <!-- logged in -->
                <ng-container *ngSwitchCase="EAccountStatus.loggedIn">
                    <ng-container *ngTemplateOutlet="disabledEmailTpl"></ng-container>
                    <ng-container *ngTemplateOutlet="loggedInTpl"></ng-container>
                    <ng-container *ngTemplateOutlet="continueTpl"></ng-container>
                </ng-container>

                <!-- guest checkout -->
                <ng-container *ngSwitchCase="EAccountStatus.guestCheckout">
                    <ng-container *ngTemplateOutlet="disabledEmailTpl"></ng-container>
                    <ng-container *ngTemplateOutlet="guestCheckoutTpl"></ng-container>
                    <ng-container *ngTemplateOutlet="continueTpl"></ng-container>
                </ng-container>

                <!-- log-in -->
                <ng-container *ngSwitchCase="EAccountStatus.login">
                    <ng-container *ngTemplateOutlet="emailTpl"></ng-container>
                    <ng-container *ngTemplateOutlet="loginTpl"></ng-container>
                    <!-- <ng-container *ngTemplateOutlet="newsletterTpl"></ng-container> -->
                    <ng-container *ngTemplateOutlet="continueTpl"></ng-container>
                    <action class="w-12 m-t m-t-3-s button-1"
                            (click)="continueAsGuest()">{{ 'Continue as guest' | translate }}</action>
                </ng-container>

                <!-- if should registr : create account form -->
                <ng-container *ngSwitchCase="EAccountStatus.registration">
                    <ng-container *ngTemplateOutlet="emailTpl"></ng-container>
                    <ng-container *ngTemplateOutlet="registrationTpl"></ng-container>
                </ng-container>

                <!-- if is new user: new user data -->
                <ng-container *ngSwitchCase="EAccountStatus.newUser">
                    <p class="p2 m-b-5 m-b-6-s">{{'You can create an account after checkout.' | translate}}</p>
                    <ng-container *ngTemplateOutlet="emailTpl"></ng-container>
                    <ng-container *ngTemplateOutlet="newUserTpl"></ng-container>
                    <!-- <ng-container *ngTemplateOutlet="newsletterTpl"></ng-container> -->
                    <ng-container *ngTemplateOutlet="continueTpl"></ng-container>
                </ng-container>

            </div>
        </checkout-expandable>


    </section1>

    <!--

    Template for: email input

    -->
    <ng-template #emailTpl>
        <input-wrap>
            <input class="input"
                   type="email"
                   validatePattern="email"
                   autocomplete="email"
                   name="email"
                   [attr.placeholder]="'Email address'"
                   [muiInput]="('Email address'| translate)"
                   maxlength="80"
                   [(ngModel)]="email"
                   [ngModelOptions]="{updateOn: 'blur'}"
                   required
                   email
                   #emailInput
                   (keyup.enter)="emailInput.blur()">
        </input-wrap>
    </ng-template>

    <!--

    Template for: disabled email input

    -->
    <ng-template #disabledEmailTpl>
        <input-wrap class="block">
            <input class="input pe-none"
                   [muiInput]="('Email address'| translate)"
                   maxlength="80"
                   [(ngModel)]="checkoutFormComponent.email"
                   name="email"
                   required
                   [value]="checkoutFormComponent.email" />
        </input-wrap>
    </ng-template>

    <!--

    Template for: newsletter signup

    -->
    <ng-template #newsletterTpl>
        <input-wrap class="m-t-9 m-t-6-s m-b-6 block m-b-2-s"
                    *ngIf="checkResult && !checkResult.newsletter">

            <p class="flex flex-middle">
                <i class="icon-email"
                   style="font-size: 1.35em;"></i>
                <span class="s1 m-l-3">{{'Sign up to our newsletter' | translate}}</span>
            </p>

            <div class="left p2 col-11 m-t-5 m-t-4-s">
                <p class="p2 inline-s inline-m">
                    {{ 'By signing up to receive our newsletter you accept our' | translate}}
                </p>
                <a class="link"
                   target="_blank"
                   routerLink="/privacy-policy">{{'Privacy policy' | translate}}</a> and
                <a class="link"
                   target="_blank"
                   routerLink="/terms-and-conditions">{{'Terms & Conditions'| translate}}</a>.
            </div>

            <radio-group class="inline-flex m-t-5 p-l-1 m-t-6-s"
                         name="newsletter"
                         [(ngModel)]="checkoutFormComponent.data.newsletter">
                <radio value="1">{{ 'Yes, please' | translate }}</radio>
                <radio value="0"
                       class="m-l-14 m-l-11-s m-l-11-m">{{ 'No, thanks' | translate }}</radio>
            </radio-group>
        </input-wrap>
    </ng-template>

    <!--

    Template for: logging in (except for the email field)

    -->
    <ng-template #loginTpl>
        <p class="p2 col-1 m-t-5">
            {{'Please enter your password' | translate}}
        </p>

        <!-- password input -->
        <input-wrap class="w-12 m-t-6 is-password">
            <view-password>
                <input class="input"
                       type="password"
                       name="password"
                       [attr.placeholder]="'Enter password'"
                       required
                       [muiInput]="'Password'| translate"
                       [(ngModel)]="data.password"
                       (keyup.enter)="continue()">
            </view-password>
        </input-wrap>

        <!-- reset my password -->
        <div class="m-t-5">
            <action class="button-inline p1"
                    [status]="passwordStatus"
                    (click)="resetPassword()"> {{ 'Forgot Password?' | translate }}</action>

            <result [status]="passwordStatus"
                    [success]="'We\'ve sent you an email with a link to reset your password.'| translate">
            </result>
        </div>

    </ng-template>


    <!--

    Template for: resfistration form (except for the email field)

    -->
    <ng-template #registrationTpl>
        <span translate>Registration is not supported</span>
    </ng-template>


    <!--

    Template for: new user (except for the email field)
    here there is no registration, just data for the new user

    -->
    <ng-template #newUserTpl>
        <!-- first name -->
        <input-wrap class="m-t-6 m-t-5-s block">
            <input class="input"
                   type="text"
                   autocomplete="given-name"
                   name="firstname"
                   [muiInput]="('First name'| translate)"
                   validatePattern="name"
                   maxlength="100"
                   required
                   [(ngModel)]="shippingData.firstname">
        </input-wrap>

        <!-- last name -->
        <input-wrap class="m-t-5 m-t-6-s m-b-5 block">
            <input class="input"
                   type="text"
                   autocomplete="family-name"
                   name="lastname"
                   [muiInput]="('Last name'| translate)"
                   validatePattern="name"
                   maxlength="50"
                   required
                   [(ngModel)]="shippingData.lastname">
        </input-wrap>


    </ng-template>

    <!--

    Template for: logged in user

    -->
    <ng-template #loggedInTpl>
        <h6 class="s1 m-t m-t-5-s">{{'Not you?' | translate}}</h6>
        <div class="m-t-2">
            <action class="button-inline p1"
                    [status]="logoutStatus"
                    (click)="logout()">
                <span>{{'Click here'| translate }}</span>
            </action><span class="col-12-s"
                  sizeClass="XL: p2, SM: c1">
                {{ 'to logout' | translate }}
                ({{ 'items in your bag will be kept' | translate}})
            </span>
        </div>
    </ng-template>

    <!--

    Template for: guest checkout

    -->
    <ng-template #guestCheckoutTpl>
        <checkout-change-section sectionTitle="You are using guest checkout."
                                 class="block m-t-5">
            <div class="m-t-2">
                <action class="button-inline p2"
                        (click)="leaveGuestCheckout()">
                    <span>{{'Click here'| translate }}</span>
                </action><span class="col-12-s p2">
                    {{ 'if you want to sign in.' | translate }}
                </span>
            </div>
        </checkout-change-section>
    </ng-template>

    <!--

    Template for: submission button

    -->
    <ng-template #continueTpl>
        <!-- [attr.disabled]="!isValid" // add it if you want button to be disabled when invalid -->
        <action class="w-12 m-t m-t-5-s button"
                [status]="continueStatus"
                (click)="continue()">
            {{ continueLabel | translate }}
        </action>

        <!-- result -->
        <result [status]="continueStatus"></result>
    </ng-template>

</ng-form>


<!-- step for validation hack -->
<ng-form #stepForm="ngForm">
    <!-- dummy field for step validataion for step -->
    <input type="hidden"
           name="dummy"
           [(ngModel)]="dummy"
           required
           *ngIf="!isValid">
</ng-form>